import React from "react";
import "../about/about.css";
import AboutImage from "../../assets/img-profil.webp";
import CV from "../../assets/edris-cv-alternance.pdf";
import { IoMdDownload } from "react-icons/io";
import Card from "../../components/card/Card";
import data from "./data";

const About = () => {
  return (
    <section id="about" data-aos="fade-in">
      <div className="container about__container">
        <div className="about__left">
          <div className="about__portrait">
            <img src={AboutImage} alt="Profil" />
          </div>
        </div>
        <div className="about__right">
          <h2>À propos de moi</h2>
          <div className="about__cards">
            {data.map((item) => (
              <Card key={item.aboutId} className="about__card">
                <span className="about__card-icon">{item.icon}</span>
                <h5>{item.title}</h5>
                <small>{item.desc}</small>
              </Card>
            ))}
          </div>
          <p>
          Mon parcours s'est construit sur deux axes : des projets complets livrés de bout en bout, et une approche systématique de la sécurité à chaque couche.
          Sur le volet messagerie d'entreprise, j'ai déployé un Exchange 2019 on-premise intégré à Active Directory, sécurisé par AD FS et Cisco Duo MFA, avec un DNS split-brain — Cloudflare pour l'externe, AD DNS pour l'interne. J'ai contourné le blocage port 25 d'un FAI via un IP Public sur VPS et j'ai utilisé SMTP2GO pour la réputation de mon service mail; j'ai aussi isolé le serveur mail derrière un VPN WireGuard hub-and-spoke. Ce projet m'a appris à résoudre des contraintes réelles, pas des cas d'école.
          </p>
          <p>
            Ce qui me distingue, c'est ma capacité à contourner les obstacles techniques pour livrer un service fonctionnel et sécurisé. Qu'il s'agisse de pallier les restrictions d'un FAI en routant le trafic SMTP via un VPS public, d'implémenter une authentification multifacteur (MFA) stricte, ou de garantir la continuité d'activité (PCA), j'aborde chaque défi avec une logique d'ingénierie et une rigueur professionnelle. Je suis aujourd'hui prêt à mettre ce pragmatisme au service de votre infrastructure.
          </p>
          <a href={CV} download className="btn primary">
            Télécharger le CV <IoMdDownload />
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
